// @flow

import styled from "styled-components";

import DefaultButton from "../../_atom/Buttons/default";

import buildColor from "../../_static/ColorPalette";
import { buildText } from "../../_atom/Text";
import { fontNormal } from "../../_static/Typography";

export const SortItemWrapper = styled.li`
  list-style-type: none;
  height: 41px;
  display: flex;
  padding: ${({ showFavorite }) => (showFavorite ? "0 8px 0 0" : "0 8px")};
  background-color: ${buildColor("white", "100")};

  &:not(:last-child) {
    border-bottom: 1px solid ${buildColor("blue", "100")};
  }

  &:active {
    background-color: ${buildColor("blue", "000")};
  }
`;

export const FavoriteWrapper = styled.div`
  width: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${buildColor("white", "0")};
`;

export const ButtonWrapper = styled(DefaultButton)`
  width: 100%;
  display: flex;
  padding-right: 43px;
  justify-content: space-between;
  align-items: center;
  background-color: ${buildColor("white", "0")};
  position: relative;

  & > svg {
    position: absolute;
    right: 4px;
    top: calc(50% - 8px);
  }
`;

export const OptionItem = styled.span`
  color: ${buildColor("grey", "800")};

  &:not(:last-child) {
    margin-right: 4px;
    padding-right: 4px;
    border-right: 1px solid ${buildColor("grey", "800")};
  }
`;

export const Description = styled(
  buildText({
    tag: "span",
    fontSize: 12,
    color: buildColor("grey", "900"),
    bold: false,
    uppercase: true
  })
)`
  display: block;
  text-align: left;
  padding-bottom: 2px;
`;

export const LoginMessageWrapper = styled.div`
  border-bottom: 1px solid ${buildColor("blue", "100")};
`;

export const Circle = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 50%;
  border: 1px solid ${({ borderColor }) => borderColor};
  position: absolute;
  right: 4px;
  top: calc(50% - ${({ size }) => size / 2}px);
`;

export const DefaultInfo = styled.div`
  position: relative;
  box-shadow: inset 0 -1px 0 0 ${buildColor("blue", "100")};
  background-color: ${buildColor("blue", "000")};
  padding: 8px 8px 10px;
  color: ${buildColor("grey", "800")};
  font-size: 14px;
  font-family: ${fontNormal};

  &::after,
  &::before {
    content: "";
    display: block;
    position: absolute;
    top: calc(100% - 1px);
    width: 0;
    height: 0;
    border-style: solid;
  }

  &::after {
    left: 14px;
    border-color: ${buildColor("blue", "000")} transparent transparent
      transparent;
    border-width: 6px;
  }

  &::before {
    left: 13px;
    border-color: ${buildColor("blue", "100")} transparent transparent
      transparent;
    border-width: 7px;
  }
`;
